module.exports = __webpack_public_path__ + "1e0e646a9e671d8d59288fec821fd4f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/N@2x.png
// module id = 829
// module chunks = 0